import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../../../Components/Form";
import { IFinanciamentoProduto } from "../../../../../../Interfaces/Vendas/Produtos/ProdutosInterfaces";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { CadastroFinanceiroProdutoVendasController } from "../../../../../../Controllers/Vendas/Produtos/ProdutosController";

interface IAdicionarEditarFinanciamentoProps {
    ID_PRODUTO: number;
    setShow: (show: boolean) => void;
    updateListFinanciamento: (
        ...args: any[]
    ) => Promise<IFinanciamentoProduto[] | undefined>;
    financiamento?: IFinanciamentoProduto;
}

export default function AdicionarEditarFinanciamento(
    props: IAdicionarEditarFinanciamentoProps
) {
    const { ID_PRODUTO, setShow, updateListFinanciamento, financiamento } =
        props;

    const {
        execute: cadastrarFinanciamento,
        loading: cadastrarFinanciamentoLoading,
    } = useAsyncCallback(CadastroFinanceiroProdutoVendasController);

    async function handleSubmit(formData: IFinanciamentoProduto) {
        if (financiamento) {
            cadastrarFinanciamento({
                ...formData,
                VL_PERCENTUAL_ANUAL: formData.VL_PERCENTUAL_ANUAL.replace(
                    ",",
                    "."
                ),
                VL_PERCENTUAL_MENSAL: formData.VL_PERCENTUAL_MENSAL.replace(
                    ",",
                    "."
                ),
                VL_PERCENTUAL_ENTRADA: formData.VL_PERCENTUAL_ENTRADA.replace(
                    ",",
                    "."
                ),
                ID_EMPREENDIMENTO: ID_PRODUTO,
                ID_FINANCEIRO_EMPREENDIMENTO:
                    financiamento.ID_FINANCEIRO_EMPREENDIMENTO,
            }).then(() => {
                setShow(false);
                updateListFinanciamento();
            });
        } else {
            cadastrarFinanciamento({
                ...formData,
                VL_PERCENTUAL_ANUAL: formData.VL_PERCENTUAL_ANUAL.replace(
                    ",",
                    "."
                ),
                VL_PERCENTUAL_MENSAL: formData.VL_PERCENTUAL_MENSAL.replace(
                    ",",
                    "."
                ),
                VL_PERCENTUAL_ENTRADA: formData.VL_PERCENTUAL_ENTRADA.replace(
                    ",",
                    "."
                ),
                ID_EMPREENDIMENTO: ID_PRODUTO,
                ID_FINANCEIRO_EMPREENDIMENTO: undefined,
            }).then(() => {
                setShow(false);
                updateListFinanciamento();
            });
        }
    }

    return (
        <UnForm handleSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6">
                    <div className="card card-custom mb-4">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Entrada</h5>
                        </div>
                        <div className="card-body">
                            <UnForm.Input
                                name="VL_PERCENTUAL_ENTRADA"
                                label="Percentual de Entrada (%)"
                                type="decimal"
                                required
                                placeholder="Ex: 20.5"
                                defaultValue={
                                    financiamento?.VL_PERCENTUAL_ENTRADA
                                }
                            />
                            <UnForm.Input
                                name="VL_QUANTIDADE_ENTRADA"
                                label="Quantidade de Entrada"
                                type="number"
                                required
                                min={1}
                                placeholder="Ex: 1"
                                defaultValue={
                                    financiamento?.VL_QUANTIDADE_ENTRADA
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card card-custom mb-4">
                        <div className="card-header">
                            <h5 className="card-title mb-0">
                                Parcelas Mensais
                            </h5>
                        </div>
                        <div className="card-body">
                            <UnForm.Input
                                name="VL_PERCENTUAL_MENSAL"
                                label="Percentual Mensal (%)"
                                type="decimal"
                                required
                                placeholder="Ex: 1.5"
                                defaultValue={
                                    financiamento?.VL_PERCENTUAL_MENSAL
                                }
                            />
                            <UnForm.Input
                                name="VL_QUANTIDADE_MENSAL"
                                label="Quantidade de Parcelas"
                                type="number"
                                required
                                min={1}
                                placeholder="Ex: 12"
                                defaultValue={
                                    financiamento?.VL_QUANTIDADE_MENSAL
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card card-custom mb-4">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Parcelas Anuais</h5>
                        </div>
                        <div className="card-body">
                            <UnForm.Input
                                name="VL_PERCENTUAL_ANUAL"
                                label="Percentual Anual (%)"
                                type="decimal"
                                required
                                placeholder="Ex: 10"
                                defaultValue={
                                    financiamento?.VL_PERCENTUAL_ANUAL
                                }
                            />
                            <UnForm.Input
                                name="VL_QUANTIDADE_ANUAL"
                                label="Quantidade de Parcelas"
                                type="number"
                                required
                                placeholder="Ex: 5"
                                defaultValue={
                                    financiamento?.VL_QUANTIDADE_ANUAL
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card card-custom mb-4">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Taxas de Juros</h5>
                        </div>
                        <div className="card-body">
                            <UnForm.Input
                                name="VL_TAXA_JUROS_MENSAL"
                                label="Taxa de Juros Mensal (%)"
                                type="decimal"
                                required
                                placeholder="Ex: 0.99"
                                defaultValue={
                                    financiamento?.VL_TAXA_JUROS_MENSAL
                                }
                            />
                            <UnForm.Input
                                name="VL_TAXA_JUROS_ANUAL"
                                label="Taxa de Juros Anual (%)"
                                type="decimal"
                                required
                                placeholder="Ex: 12.68"
                                defaultValue={
                                    financiamento?.VL_TAXA_JUROS_ANUAL
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>

            <UnForm.SubmitButton
                icon={financiamento ? faEdit : faPlus}
                color={financiamento ? "primary" : "success"}
                loading={cadastrarFinanciamentoLoading}
                loadingSize="sm"
                wrapperClassName="m-0 d-flex justify-content-end"
            >
                {financiamento
                    ? "Editar Financiamento"
                    : "Cadastrar Financiamento"}
            </UnForm.SubmitButton>
        </UnForm>
    );
}
